// Central SEO configuration + JSON-LD builders (schema.org)
import { CONTACT_INFO, SOCIAL_LINKS } from "@/data/content";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://serpenstech.com").replace(/\/$/, "");
export const SITE_NAME = "Serpens Technology";
export const LEGAL_NAME = "Serpens Technology Pvt. Ltd.";
export const DEFAULT_IMAGE = `${SITE_URL}/assets/logo.webp`;
export const ORG_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

export const absUrl = (path = "/") => {
  if (/^https?:\/\//.test(path)) return path;
  const clean = path === "/" ? "/" : `/${path.replace(/^\/+/, "").replace(/\/+$/, "")}`;
  return `${SITE_URL}${clean === "/" ? "/" : clean}`;
};

export const organizationRef = { "@id": ORG_ID };

// Full Organization + LocalBusiness node (genuine company info only — no ratings/reviews)
export const organizationSchema = () => ({
  "@type": ["Organization", "ProfessionalService"],
  "@id": ORG_ID,
  name: LEGAL_NAME,
  alternateName: SITE_NAME,
  url: `${SITE_URL}/`,
  logo: DEFAULT_IMAGE,
  image: DEFAULT_IMAGE,
  email: CONTACT_INFO.email,
  telephone: "+91-82170-64852",
  slogan: "Building Digital Solutions That Scale Businesses.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "36, 2nd Main Pipeline Road, Mathikere",
    addressLocality: "Bengaluru",
    addressRegion: "Karnataka",
    postalCode: "560054",
    addressCountry: "IN",
  },
  areaServed: [
    { "@type": "City", name: "Bengaluru" },
    { "@type": "State", name: "Karnataka" },
    { "@type": "Country", name: "India" },
    "Worldwide",
  ],
  sameAs: SOCIAL_LINKS.map((s) => s.url).filter((u) => !u.includes("/invites/")),
});

export const breadcrumbSchema = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: absUrl(it.path),
  })),
});

export const faqSchema = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const serviceSchema = ({ name, description, path, serviceType, offers = [] }) => ({
  "@type": "Service",
  "@id": `${absUrl(path)}#service`,
  name,
  description,
  serviceType: serviceType || name,
  url: absUrl(path),
  provider: organizationRef,
  areaServed: [
    { "@type": "City", name: "Bengaluru" },
    { "@type": "Country", name: "India" },
    "Worldwide",
  ],
  ...(offers.length
    ? {
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name,
          itemListElement: offers.map((o) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name: o } })),
        },
      }
    : {}),
});

export const articleSchema = (post, path) => ({
  "@type": "BlogPosting",
  "@id": `${absUrl(path)}#article`,
  headline: post.title,
  description: post.excerpt,
  image: post.image ? [post.image] : [DEFAULT_IMAGE],
  datePublished: post.published_at,
  dateModified: post.updated_at || post.published_at,
  author: { "@type": "Person", name: post.author },
  publisher: organizationRef,
  mainEntityOfPage: absUrl(path),
  articleSection: post.category,
});
